<template>
  <div class="zjdjxq">
    <div class="djyl">
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item  :to="{ path: '/djyl' }" >党建引领</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/zjdj' }">走进党建</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/zjdjxq' }">走进党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="xq">
         <div class="title">关于2023年沧州市工业设计中心拟认定名单和2020年沧州市工业设计中心复核拟通过名单的公示</div>
        <div class="h1">
          <span>发布时间：2023-05-07</span>
          <span>来源：沧州市工业和信息化局</span>
        </div>
        <div>
          按照《沧州市工业设计2023年工作要点》工作安排，依据《沧州市工业设计中心管理办法》有关规定及文件要求，我局组织开展了2023年沧州市工业设计中心申报以及2020年沧州市工业设计中心复核评审工作，经企业申报、各县（市、区）推荐、专家评审和现场审查等环节，拟认定河北中和铸造有限公司的中和铸造成型工业设计中心等12家新申报的企业工业设计中心为沧州市工业设计中心，沧州市牧疆南北农牧机械有限公司的沧州市牧疆南北装备设计中心等8家2020年认定的沧州市工业设计中心拟复核通过。现予公示，公示期5个工作日（2023年10月16日至10月20日）。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zjdjxq"
}
</script>

<style lang="scss" scoped>
  .zjdjxq{
     background: #F5F5F5;
    .djyl{
      background: url("../../assets/djyl/djylbg.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 140px;
      color: #fff;
    }
    .content{
      width: 1200px;
      margin: 20px auto;
      .xq{
        background: #fff;
        min-height: calc(100vh - 350px);
        margin-top: 20px;
        padding: 20px;
      }
      .title{
        color: #292929;
        text-align: center;
        font-weight: 550;
        font-size: 16px;
      }
      .h1{
        line-height: 50px;
        text-align: center;
        span{
          margin-right: 50px;
        }
      }
    }
  }
</style>